export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: 'Coluna Tempo',
              attributes: { class: 'column column-50 pattern-padding' },
              components: [
      
                {
                  tagName: 'h2',
                  type:'text',
                  name:'Titulo',
                  components: 'Linha do tempo',
                  attributes: {class: 'principal-title'}, 
                  traits: [
                    {
                      type: "select",
                      options: [
                        { value: "h1", name: opts.labelN1 },
                        { value: "h2", name: opts.labelN2 },
                        { value: "h3", name: opts.labelN3 },
                        { value: "h4", name: opts.labelN4 },
                        { value: "h5", name: opts.labelN5 },
                        { value: "h6", name: opts.labelN6 },
                      ],
                      label: 'Tamanho',
                      name: "tagName",
                      changeProp: 1,
                    },
                    {
                      type:'id',
                      name:'id',
                      Label:'id',
                    }
                  ],
                },
                {
                  type:'text', 
                  content: 'Subtítulo', 
                  name:'Subtitulo',
                  attributes: {class:'subtitle text-uppercase margin-top-15'},
                }, 
                {
                  type: 'text',
                  content:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et bibendum risus. Cras faucibus viverra',
                  attributes: {class: 'body-text'},
                },
                {
                  type: 'button',
                },
              ],
              styles: `
               .principal-title{
                font-size: 30px; 
                color: #363940; 
                margin:0;
               }
               .body-text{
                font-size: 16px; 
                color: #363940; 
                margin-top:30px;
               }
               .column{
                display:flex; 
                flex-direction:column;
                align-items: flex-start;
               }
               .column-50{
                width:50%; 
               }
               @media (max-width:992px){
                .column-50{
                  width:100%; 
                }
               }
               .subtitle{
                font-size: 13px; 
                color: #747474; 
               }
               .text-uppercase{
                text-transform: uppercase;
               }
               .pattern-padding{
                 padding:75px 5%; 
               }
               .margin-top-15{
                margin-top:15px;
               }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};